import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { ISearchTmdbTitlesResponse } from './search-tmdb-titles-response';
import { searchTmdbTitlesResponseSchema } from './search-tmdb-titles-response';

export async function searchTmdbTitlesApi(
  query: string,
  mediaType: 'movie' | 'tv' = 'movie',
): Promise<IValidatedResponse<ISearchTmdbTitlesResponse>> {
  const params = new URLSearchParams({ query, mediaType });
  return getRequest<ISearchTmdbTitlesResponse>({
    path: `/sys/people/v1/import/tmdb/search?${params.toString()}`,
    schema: searchTmdbTitlesResponseSchema,
  });
}
